/* ELITE theme v2 – klein, zonder afhankelijkheden.
   Toestel onthouden (localStorage elite:device), kiezer en lades, configurator (toestelpagina),
   productvarianten, camera-aanvulling met totaal, winkelmand via AJAX. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const E = window.ELITE || { routes: { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change' }, strings: {}, money: '€{{amount_with_comma_separator}}' };
  const KEY = 'elite:device';
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function money(cents) {
    const n = (Number(cents) || 0) / 100;
    const fmt = (dec, thou, d = 2) => {
      const [i, f] = n.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? dec + f : '');
    };
    return String(E.money || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt('.', ','), amount_no_decimals: fmt(',', '.', 0), amount_with_comma_separator: fmt(',', '.'),
      amount_no_decimals_with_comma_separator: fmt(',', '.', 0), amount_with_period_and_space_separator: fmt('.', ' '),
      amount_with_space_separator: fmt(',', ' '), amount_with_apostrophe_separator: fmt('.', "'"),
    }[k] ?? fmt(',', '.'))).replace(/<[^>]+>/g, '');
  }

  /* ── Toestel onthouden ─────────────────────────────────────────────── */
  const device = {
    get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; } },
    set(d) {
      if (!d || !d.h) return;
      try { localStorage.setItem(KEY, JSON.stringify({ h: d.h, n: d.n, m: d.m })); } catch {}
      const label = $('[data-mydevice]');
      if (label && d.n) label.textContent = d.n;
    },
  };
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-device-link]');
    if (link) device.set({ h: link.dataset.h, n: link.dataset.n, m: link.dataset.m });
  });
  const devicePage = $('[data-device-page]');
  if (devicePage) device.set({ h: devicePage.dataset.h, n: devicePage.dataset.n, m: devicePage.dataset.m });
  const current = device.get();
  if (current) $$(`.devlink[data-h="${CSS.escape(current.h)}"]`).forEach((a) => a.classList.add('is-current'));

  /* ── Header: haarlijn na scrollen ──────────────────────────────────── */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Lades en modals ───────────────────────────────────────────────── */
  const overlay = $('[data-overlay]');
  let openEl = null, lastFocus = null;
  function open(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (openEl && openEl !== el) close(false);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    if (!el.classList.contains('modal')) overlay?.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    openEl = el;
    const focus = $('[data-picker-search]', el) || $('[data-close]', el);
    setTimeout(() => focus?.focus({ preventScroll: true }), 80);
  }
  function close(restore = true) {
    if (!openEl) return;
    openEl.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    openEl = null;
    if (restore) lastFocus?.focus?.({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      if (opener.dataset.open === 'cart' && !$('[data-cart-drawer]')) return;
      e.preventDefault();
      open(opener.dataset.open);
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  /* ── Toestelkiezer: zoeken en merk ─────────────────────────────────── */
  const picker = $('[data-picker]');
  if (picker) {
    const input = $('[data-picker-search]', picker);
    const empty = $('[data-picker-empty]', picker);
    let brand = '';
    const filter = () => {
      const words = (input.value || '').toLowerCase().trim().split(/\s+/).filter(Boolean);
      let shown = 0;
      $$('[data-group]', picker).forEach((g) => {
        let any = false;
        $$('[data-device-link]', g).forEach((a) => {
          const ok = (!brand || a.dataset.m === brand) && words.every((w) => a.dataset.q.includes(w));
          a.hidden = !ok;
          if (ok) { any = true; shown++; }
        });
        g.hidden = !any;
      });
      empty.hidden = shown > 0;
    };
    input.addEventListener('input', filter);
    input.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      const first = $$('[data-device-link]', picker).find((a) => !a.hidden && !a.closest('[hidden]'));
      if (first) { e.preventDefault(); first.click(); }
    });
    $$('.picker__tabs [data-brand]', picker).forEach((b) => b.addEventListener('click', () => {
      brand = b.dataset.brand;
      $$('.picker__tabs [data-brand]', picker).forEach((x) => x.classList.toggle('is-active', x === b));
      filter();
    }));
  }

  /* Toestelkeuze op de toestelpagina: naar de pagina van het gekozen toestel */
  $$('[data-device-nav]').forEach((s) => s.addEventListener('change', () => {
    const o = s.selectedOptions[0];
    if (!o) return;
    device.set({ h: o.value, n: o.dataset.n, m: o.dataset.m });
    location.href = o.dataset.url;
  }));

  /* ── Beeldwissel (stage) ───────────────────────────────────────────── */
  function stage(root) {
    const frame = $('[data-stage]', root);
    const dots = $('[data-stage-dots]', root);
    if (!frame) return () => {};
    const visible = () => $$('[data-slide]', frame).filter((s) => !s.hidden);
    const show = (slide) => {
      $$('[data-slide]', frame).forEach((s) => s.classList.toggle('is-active', s === slide));
      const img = $('img', slide); if (img) img.loading = 'eager';
      $$('button', dots).forEach((d) => d.classList.toggle('is-active', d._slide === slide));
    };
    const rebuild = () => {
      const list = visible();
      dots.innerHTML = '';
      $('.stage__arrows', frame).hidden = list.length < 2;
      if (list.length < 2) return;
      list.forEach((s, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `${i + 1} / ${list.length}`);
        b._slide = s;
        b.classList.toggle('is-active', s.classList.contains('is-active'));
        b.addEventListener('click', () => show(s));
        dots.appendChild(b);
      });
    };
    const step = (d) => {
      const list = visible();
      if (list.length < 2) return;
      const i = list.findIndex((s) => s.classList.contains('is-active'));
      show(list[(i + d + list.length) % list.length]);
    };
    $('[data-stage-prev]', frame)?.addEventListener('click', () => step(-1));
    $('[data-stage-next]', frame)?.addEventListener('click', () => step(1));
    let x0 = null;
    frame.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    frame.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); x0 = null; });
    rebuild();
    return rebuild;
  }

  /* ── Foto vergroten ────────────────────────────────────────────────── */
  /* De kleine foto's (camera-aanvulling, opnieuw bestellen) openen groot, met de kleuren of afwerkingen erbij om te
     vergelijken. Een keuze in het venster wordt ook de keuze op de regel (aanvinken blijft aan de klant).
     items: [{ label, src, hex (kleurbolletje) of lijn (afwerking) }] */
  let zoomEl = null;
  const big = (src) => String(src || '').replace(/([?&]width=)\d+/, '$1960');
  function zoom({ title, items, index = 0, pick }) {
    const list = items.filter((it) => it.src);
    if (!list.length) return;
    if (!zoomEl) {
      zoomEl = document.createElement('dialog');
      zoomEl.className = 'zoom';
      zoomEl.innerHTML = `<div class="zoom__inner">
        <button class="zoom__close" type="button" aria-label="${esc(E.strings.close || 'Sluiten')}"><svg class="i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>
        <div class="zoom__img"><img alt=""></div>
        <div class="zoom__foot"><p class="zoom__title"><span></span><small></small></p><div class="zoom__opts"></div></div>
      </div>`;
      document.body.appendChild(zoomEl);
      $('.zoom__close', zoomEl).addEventListener('click', () => zoomEl.close());
      zoomEl.addEventListener('click', (e) => { if (e.target === zoomEl) zoomEl.close(); });
      zoomEl.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    }
    const img = $('.zoom__img img', zoomEl);
    const opts = $('.zoom__opts', zoomEl);
    const show = (i) => {
      img.src = big(list[i].src);
      img.alt = `${title} ${list[i].label || ''}`.trim();
      $('.zoom__title span', zoomEl).textContent = title;
      $('.zoom__title small', zoomEl).textContent = list[i].label || '';
      $$('button', opts).forEach((b, j) => b.setAttribute('aria-pressed', String(j === i)));
    };
    opts.innerHTML = '';
    opts.hidden = list.length < 2;
    if (list.length > 1) list.forEach((it, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      if (it.hex) { b.className = 'swatch'; b.style.setProperty('--sw', it.hex); b.setAttribute('aria-label', it.label); }
      else { b.className = 'finish__opt'; b.dataset.lijn = it.lijn || ''; b.innerHTML = `<span class="dot"></span>${esc(it.label)}`; }
      b.addEventListener('click', () => { show(i); pick?.(it); });
      opts.appendChild(b);
    });
    list.forEach((it) => { new Image().src = big(it.src); });
    show(Math.max(0, list.indexOf(items[index])));
    document.documentElement.style.overflow = 'hidden';
    zoomEl.showModal();
  }

  /* ── Camera-aanvulling ─────────────────────────────────────────────── */
  /* opts.base: of er een screenprotector bij zit (standaard ja). Zonder geldt het setvoordeel niet, net als de
     korting in Shopify (opnieuw bestellen op de installatiepagina, waar de screenprotector uit te vinken is). */
  function addons(root, onChange, opts = {}) {
    const base = opts.base || (() => true);
    const block = $('[data-addons]', root);
    const list = $('[data-addon-list]', root);
    const tpl = $('[data-addon-template]', root);
    const data = JSON.parse($('[data-camera]')?.textContent || '[]');
    if (!block || !tpl) return { render() {}, refresh: onChange, items: () => [], total: () => 0, saving: () => 0 };
    /* Setvoordeel: per extra onderdeel x% op de extra's, met een maximum (gelijk aan de kortingsfunctie) */
    const SET = E.set || { per: 10, max: 25 };
    const pct = () => (base() ? Math.min(SET.per * checked().length, SET.max) : 0);
    /* Zelfde afronding als Shopify: het kortingsbedrag wordt naar beneden afgerond op hele centen */
    const net = (price, p = pct()) => Number(price) - Math.floor((Number(price) * p) / 100);
    /* Elke regel toont de prijs die je betaalt als hij erbij zit: aangevinkt het huidige percentage,
       niet aangevinkt het percentage dat geldt zodra je hem toevoegt. */
    const note = $('.addons__note', block);
    const refresh = () => {
      const rows = $$('[data-addon]', list);
      const on = rows.filter((el) => $('[data-addon-check]', el).checked).length;
      rows.forEach((el) => {
        const isOn = $('[data-addon-check]', el).checked;
        const p = base() ? Math.min(SET.per * (isOn ? on : on + 1), SET.max) : 0;
        const price = Number(el.dataset.price || 0);
        const now = net(price, p);
        $('[data-addon-price]', el).innerHTML = p > 0
          ? `<s class="addon__was">${money(price)}</s><span class="addon__now">${money(now)}</span>`
          : money(price);
      });
      if (note) {
        const all = Math.min(SET.per * rows.length, SET.max);
        note.textContent = !base()
          ? (E.strings.setScreen || '−%p% met screenprotector').replace('%p', SET.per)
          : rows.length > 1
          ? (E.strings.setMulti || '−%p% per onderdeel · −%a% samen').replace('%p', SET.per).replace('%a', all)
          : (E.strings.setOne || '−%p% setvoordeel').replace('%p', SET.per);
      }
      onChange();
    };

    /* seed: beginkeuze voor regels die er nog niet stonden, bijv. { lens: { checked: true, color: 'Zwart' } } */
    function render(deviceHandle, seed = {}) {
      const prev = new Map($$('[data-addon]', list).map((el) => [el.dataset.key, { checked: $('[data-addon-check]', el).checked, color: el.dataset.color }]));
      list.innerHTML = '';
      let count = 0;
      for (const prod of data) {
        /* Alleen wat te koop is: geen uitverkochte kleuren, en geen regel als er voor dit toestel niets leverbaar is */
        const vs = prod.variants.filter((v) => v.available && v.devices.includes(deviceHandle));
        if (!vs.length) continue;
        count++;
        const el = tpl.content.firstElementChild.cloneNode(true);
        el.dataset.key = prod.key;
        el.dataset.lijn = prod.key;
        const was = prev.get(prod.key) || seed[prod.key];
        const pick = vs.find((v) => v.color === was?.color) || vs[0];
        const check = $('[data-addon-check]', el);
        check.checked = !!was?.checked;
        check.setAttribute('aria-label', prod.title);
        $('[data-addon-title]', el).textContent = prod.title;
        /* ? : uitleg wat het is (veel mensen kennen een lens- of frameprotector niet) */
        const info = $('[data-addon-info]', el);
        const more = $('[data-addon-more]', el);
        if (prod.info && info && more) {
          more.textContent = prod.info;
          info.addEventListener('click', (e) => {
            e.stopPropagation();
            more.hidden = !more.hidden;
            info.setAttribute('aria-expanded', String(!more.hidden));
          });
        } else info?.remove();
        const img = $('[data-addon-img]', el);
        const sw = $('[data-addon-swatches]', el);
        const select = (v) => {
          el.dataset.id = v.id; el.dataset.price = v.price; el.dataset.color = v.color;
          $('[data-addon-color]', el).textContent = v.color;
          if (img) { img.src = v.img || prod.img || ''; img.alt = `${prod.title} ${v.color || ''}`.trim(); img.parentNode.hidden = !img.src; }
          $$('.swatch', sw).forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.id) === v.id)));
          refresh();
        };
        img?.parentNode.addEventListener('click', (e) => {
          e.stopPropagation();
          const items = vs.map((v) => ({ label: v.color, hex: v.hex, src: v.img || prod.img, v }));
          zoom({ title: prod.title, items, index: vs.findIndex((v) => v.id === Number(el.dataset.id)), pick: (it) => select(it.v) });
        });
        if (vs.length > 1) {
          vs.forEach((v) => {
            const b = document.createElement('button');
            b.type = 'button'; b.className = 'swatch';
            b.style.setProperty('--sw', v.hex); b.dataset.id = v.id;
            b.setAttribute('aria-label', v.color);
            b.addEventListener('click', (e) => { e.stopPropagation(); check.checked = true; select(v); });
            sw.appendChild(b);
          });
        }
        el.addEventListener('click', (e) => { if (e.target === check) return; check.checked = !check.checked; refresh(); });
        check.addEventListener('change', refresh);
        list.appendChild(el);
        select(pick);
      }
      block.hidden = count === 0;
      refresh();
    }
    const checked = () => $$('[data-addon]', list).filter((el) => $('[data-addon-check]', el).checked);
    return {
      render,
      refresh,
      items: (props) => checked().map((el) => ({ id: Number(el.dataset.id), quantity: 1, ...(props ? { properties: props } : {}) })),
      total: () => checked().reduce((s, el) => s + net(el.dataset.price || 0), 0),
      saving: () => checked().reduce((s, el) => s + Number(el.dataset.price || 0) - net(el.dataset.price || 0), 0),
    };
  }

  function showSaving(root, cents) {
    const el = $('[data-saving]', root);
    if (!el) return;
    el.hidden = !(cents > 0);
    if (cents > 0) el.textContent = (E.strings.saving || 'incl. %s setvoordeel').replace('%s', money(cents));
  }

  /* ── Koopbalk op mobiel ────────────────────────────────────────────── */
  function buybar(trigger, onBuy) {
    const bar = $('[data-buybar]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    /* Mobiel: pas na voorbij scrollen. Desktop: ook als de knop nog onder de vouw staat (kleine schermen). */
    const desktop = window.matchMedia('(min-width: 990px)');
    let last = null;
    const update = (entry = last) => {
      if (!entry) return;
      last = entry;
      const out = !entry.isIntersecting && (desktop.matches || entry.boundingClientRect.top < 0);
      bar.classList.toggle('is-visible', out);
      bar.setAttribute('aria-hidden', String(!out));
    };
    new IntersectionObserver(([entry]) => update(entry)).observe(trigger);
    desktop.addEventListener('change', () => update());
    $('[data-buybar-btn]', bar).addEventListener('click', onBuy);
  }

  /* ── Toestelpagina: configurator ───────────────────────────────────── */
  const config = $('[data-config]');
  if (config && window.eliteConfig) {
    const rebuild = stage(config);
    const totalEl = $('[data-total]', config);
    const addBtn = $('[data-config-add]', config);
    const chosen = () => $('[data-choice][aria-checked="true"]', config);
    const extra = addons(config, () => update());
    function update() {
      const btn = chosen();
      if (!btn) return;
      const total = Number(btn.dataset.price || 0) + extra.total();
      totalEl.textContent = money(total);
      showSaving(config, extra.saving());
      const barPrice = $('[data-buybar-price]'); if (barPrice) barPrice.textContent = `${btn.dataset.name} · ${money(total)}`;
    }
    $$('[data-choice]', config).forEach((b) => b.addEventListener('click', () => {
      if (window.eliteConfig.choose(b.dataset.choice)) {
        try { localStorage.setItem('elite:line', b.dataset.choice); } catch {}
        rebuild(); update();
      }
    }));
    extra.render(config.dataset.h);
    update();
    $('[data-config-form]', config).addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = chosen();
      if (!btn?.dataset.id) return;
      const props = { _toestel: config.dataset.h };
      addItems([{ id: Number(btn.dataset.id), quantity: 1, properties: props }, ...extra.items(props)], addBtn);
    });
    buybar(addBtn, () => $('[data-config-form]', config).requestSubmit());
  }

  /* ── Productpagina ─────────────────────────────────────────────────── */
  const product = $('[data-product]');
  if (product && window.eliteProduct) {
    const { variants, apply } = window.eliteProduct;
    const rebuild = stage(product);
    const totalEl = $('[data-total]', product);
    const addBtn = $('[data-add-btn]', product);
    const variant = () => variants.find((v) => String(v.id) === product.dataset.variant) || variants[0];
    const barPrice = $('[data-buybar-price]');
    const showTotal = (v) => { const t = money(v.price + extra.total()); totalEl.textContent = t; if (barPrice) barPrice.textContent = t; showSaving(product, extra.saving()); };
    const extra = addons(product, () => showTotal(variant()));
    const choose = (v, h) => {
      apply(v, h);
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      url.searchParams.delete('toestel');
      history.replaceState(null, '', url);
      const h2 = product.dataset.device;
      const opt = h2 && $(`[data-device-select] option[value="${CSS.escape(h2)}"]`, product);
      if (opt) device.set({ h: h2, n: opt.dataset.n, m: opt.dataset.m });
    };
    const deviceSelect = $('[data-device-select]', product);
    deviceSelect?.addEventListener('change', () => {
      const h = deviceSelect.value;
      const color = $('[data-option="1"]', product)?.value;
      /* Het meest specifieke glas voor dit toestel; bij camera dezelfde kleur als die er is */
      const same = variants.filter((x) => x.devices.includes(h)).sort((a, b) => a.devices.length - b.devices.length);
      const v = same.find((x) => x.options[1] === color && x.available) || same.find((x) => x.available) || same[0];
      if (v) choose(v, h);
    });
    product.addEventListener('click', (e) => {
      const sw = e.target.closest('[data-color-swatches] .swatch');
      if (!sw) return;
      const v = variants.find((x) => x.id === Number(sw.dataset.variant));
      if (v) choose(v, product.dataset.device);
    });
    product.addEventListener('elite:variant', (e) => {
      rebuild();
      extra.render(product.dataset.device || e.detail.devices[0]);
      showTotal(e.detail);
    });
    extra.render(product.dataset.device || variant().devices[0]);
    showTotal(variant());
    $('[data-product-form]', product).addEventListener('submit', (e) => {
      e.preventDefault();
      const v = variant();
      const h = product.dataset.device || (v.devices.length === 1 ? v.devices[0] : null);
      const props = h ? { _toestel: h } : undefined;
      addItems([{ id: v.id, quantity: 1, ...(props ? { properties: props } : {}) }, ...extra.items(props)], addBtn);
    });
    buybar(addBtn, () => $('[data-product-form]', product).requestSubmit());
  }

  /* ── Installatiepagina: opnieuw bestellen ──────────────────────────── */
  /* Vrije keuze voor het toestel van de klant: een screenprotector in de afwerking naar keuze en los de lens- en
     frameprotector. Niets staat standaard aangevinkt; wel staat de afwerking of kleur van het gescande product klaar.
     Alleen wat te koop is. Past het glas op meer toestellen (bijv. iPhone 16 / 15), dan
     kiest de klant eerst zijn toestel: de camera verschilt per toestel, dus niet gokken. */
  const reorder = $('[data-reorder]');
  const own = window.eliteInstall;
  if (reorder && own && own.v && own.dh?.length) {
    const screens = JSON.parse($('[data-screens]')?.textContent || '[]');
    const row = $('[data-ro-screen]', reorder);
    const check = $('[data-ro-screen-check]', reorder);
    const finish = $('[data-ro-finish]', reorder);
    const img = $('[data-ro-screen-img]', reorder);
    const btn = $('[data-ro-add]', reorder);
    const totalEl = $('[data-total]', reorder);
    const devices = own.dh;
    const mine = device.get();
    let h = devices.length === 1 ? devices[0] : devices.includes(mine?.h) ? mine.h : null;
    let line = own.k === 'screen' ? own.key : (() => { try { return localStorage.getItem('elite:line'); } catch { return null; } })();
    let pick = null;
    const label = (s) => s.lijn || s.title.replace(/^ELITE\s+/, '');
    /* Per afwerking het meest specifieke glas voor dit toestel (het gescande als dat past) */
    const options = () => screens.map((s) => {
      const vs = s.variants.filter((v) => v.available && v.devices.includes(h)).sort((a, b) => a.devices.length - b.devices.length);
      return { s, v: vs.find((v) => v.id === own.v) || vs[0] };
    }).filter((o) => o.v);
    const screenOn = () => !row.hidden && check.checked && !!pick;

    function renderScreen() {
      const opts = options();
      row.hidden = !opts.length;
      if (!opts.length) { pick = null; return; }
      const chosen = opts.find((o) => o.s.key === line) || opts[0];
      line = chosen.s.key;
      pick = chosen.v;
      finish.innerHTML = '';
      finish.hidden = opts.length < 2;
      opts.forEach((o) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'finish__opt'; b.dataset.lijn = o.s.key;
        b.setAttribute('aria-pressed', String(o === chosen));
        b.innerHTML = `<span class="dot"></span>${esc(label(o.s))}`;
        b.addEventListener('click', (e) => { e.stopPropagation(); line = o.s.key; check.checked = true; renderScreen(); extra.refresh(); });
        finish.appendChild(b);
      });
      $('[data-ro-screen-name]', reorder).textContent = label(chosen.s);
      $('[data-ro-screen-price]', reorder).textContent = money(pick.price);
      img.src = pick.img || '';
      img.alt = chosen.s.title;
      img.parentNode.hidden = !pick.img;
    }
    function show() {
      const count = (screenOn() ? 1 : 0) + extra.items().length;
      totalEl.textContent = money((screenOn() ? pick.price : 0) + extra.total());
      totalEl.classList.toggle('is-empty', count === 0);
      showSaving(reorder, extra.saving());
      if (!E.paused) btn.disabled = count === 0;
    }
    const extra = addons(reorder, show, { base: screenOn });

    row.addEventListener('click', (e) => { if (e.target === check) return; check.checked = !check.checked; extra.refresh(); });
    check.addEventListener('change', () => extra.refresh());
    img.parentNode.addEventListener('click', (e) => {
      e.stopPropagation();
      const opts = options();
      const items = opts.map((o) => ({ label: label(o.s), lijn: o.s.key, src: o.v.img, key: o.s.key }));
      zoom({
        title: check.getAttribute('aria-label'),
        items,
        index: opts.findIndex((o) => o.s.key === line),
        pick: (it) => { line = it.key; renderScreen(); extra.refresh(); },
      });
    });

    /* Gescande lens- of frameprotector: beide staan klaar in die kleur (niet aangevinkt) */
    const seed = own.k === 'screen' ? {} : { lens: { color: own.c }, frame: { color: own.c } };
    const buy = $('.panel__buy', reorder);
    const update = () => { renderScreen(); extra.render(h, seed); buy.hidden = !h; };
    const select = $('[data-ro-devices]', reorder);
    if (select && devices.length > 1) {
      if (!h) select.innerHTML = `<option value="" disabled selected>${esc(E.strings.chooseDevice || '')}</option>`;
      devices.forEach((d, i) => { const o = document.createElement('option'); o.value = d; o.textContent = (own.dn || [])[i] || d; select.appendChild(o); });
      if (h) select.value = h;
      $('[data-ro-devices-wrap]', reorder).hidden = false;
      select.addEventListener('change', () => {
        h = select.value;
        device.set({ h, n: select.selectedOptions[0]?.textContent });
        update();
      });
    }

    update();
    reorder.hidden = !!h && row.hidden && $('[data-addons]', reorder).hidden;
    $('[data-reorder-form]', reorder).addEventListener('submit', (e) => {
      e.preventDefault();
      const props = { _toestel: h };
      const items = [...(screenOn() ? [{ id: pick.id, quantity: 1, properties: props }] : []), ...extra.items(props)];
      if (items.length) addItems(items, btn);
    });
  }

  /* ── Winkelmand ────────────────────────────────────────────────────── */
  const toast = (msg) => {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };

  async function refreshCart({ openDrawer = false } = {}) {
    if ($('[data-cart-page]')) { location.reload(); return; }
    const res = await fetch(`${E.routes.root.replace(/\/$/, '')}/?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer]', html);
    const drawer = $('[data-cart-drawer]');
    if (fresh && drawer) drawer.innerHTML = fresh.innerHTML;
    const count = Number($('[data-cart-count-value]', html)?.textContent || 0);
    $$('[data-cart-count]').forEach((c) => { c.textContent = count; c.hidden = count === 0; });
    if (openDrawer) open('cart');
  }

  async function addItems(items, btn) {
    /* Verkoop tijdelijk uit (thema-instelling sales_paused): niets in de winkelmand */
    if (E.paused) { toast(E.strings.comingSoon); return; }
    btn?.classList.add('is-loading');
    try {
      const res = await fetch(`${E.routes.cartAdd}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }),
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.description || body.message || E.strings.error);
      await refreshCart({ openDrawer: true });
    } catch (err) {
      toast(err.message || E.strings.error);
    } finally {
      btn?.classList.remove('is-loading');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    addItems([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], $('[type="submit"]', form));
  });

  async function changeLine(line, quantity) {
    try {
      const res = await fetch(`${E.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, quantity) }),
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.description || body.message);
      await refreshCart();
    } catch (err) { toast(err.message || E.strings.error); }
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-line-qty]');
    if (q) {
      const input = $(`[data-line-input="${q.dataset.lineQty}"]`, q.closest('.citem'));
      changeLine(q.dataset.lineQty, Number(input.value) + Number(q.dataset.delta));
      return;
    }
    const r = e.target.closest('[data-line-remove]');
    if (r) changeLine(r.dataset.lineRemove, 0);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) changeLine(input.dataset.lineInput, Number(input.value));
  });

  /* ── Taalkiezer (snippets/lang-switch) ── */
  $$('[data-lang]').forEach((root) => {
    const btn = $('[data-lang-btn]', root);
    const menu = $('[data-lang-menu]', root);
    const set = (open) => { btn.setAttribute('aria-expanded', String(open)); menu.hidden = !open; };
    btn.addEventListener('click', (e) => { e.stopPropagation(); set(menu.hidden); });
    document.addEventListener('click', (e) => { if (!root.contains(e.target)) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) { set(false); btn.focus(); } });
  });

  /* ── Cookie-instellingen opnieuw openen (Shopify-cookiebanner) ── */
  const cookieBtns = $$('[data-cookie-prefs]');
  if (cookieBtns.length) {
    let tries = 0;
    const ready = () => {
      if (window.privacyBanner?.showPreferences) cookieBtns.forEach((b) => { b.hidden = false; });
      else if (++tries < 20) setTimeout(ready, 500);
    };
    ready();
    cookieBtns.forEach((b) => b.addEventListener('click', () => window.privacyBanner?.showPreferences()));
  }

  /* ── Video: YouTube pas laden na klik ──────────────────────────────── */
  document.addEventListener('click', (e) => {
    const v = e.target.closest('[data-video]');
    if (!v || v.querySelector('iframe')) return;
    const f = document.createElement('iframe');
    f.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(v.dataset.video)}?autoplay=1&rel=0&modestbranding=1`;
    f.title = v.dataset.videoTitle || 'Video';
    f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    v.innerHTML = '';
    v.appendChild(f);
  });

  /* ── Verschijnen bij scrollen ──────────────────────────────────────── */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -6% 0px' });
    reveals.forEach((r) => io.observe(r));
  } else reveals.forEach((r) => r.classList.add('is-in'));
})();
